import { Link } from "react-router-dom";

interface MovieCardProps {
  id: number;
  title: string;
  slug: string;
  year: number;
  rating: number;
  categoryName: string;
  posterUrl: string;
}

export default function MovieCard({
  title,
  slug,
  year,
  rating,
  categoryName,
  posterUrl,
}: MovieCardProps) {
  return (
    <Link
      to={`/movie/${slug}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
        <img
          src={posterUrl}
          alt={title}
          title={`${title} - 春夜影院蓝光高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
        <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm text-accent-500 text-xs font-bold px-2 py-1 rounded-md">
          {rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="text-foreground-400 text-xs bg-background-950/60 backdrop-blur-sm px-2 py-0.5 rounded">
            {categoryName}
          </span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-foreground-50 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className="text-foreground-200 text-sm font-medium truncate group-hover:text-primary-400 transition-colors">
        {title}
      </h3>
      <p className="text-foreground-600 text-xs mt-1">{year}</p>
    </Link>
  );
}